package com.example.mystybag.appCore.model.addMerchantLocation

data class MerchantRegistrationReviewStoreDetailsUIState(
    val storeName: String = "",
    val storeAddress: String = "",
    val cityId: Long? = null,
    val cityName: String = "",
    val countryId: Int? = null,
    val countryName: String = "",
    val storePhoneNumber: String = "",
    val dialCode: String = "",
    val latitude: Double? = null,
    val longitude: Double? = null,
    val isLoading: Boolean = false,
    val isMapReady: Boolean = false
)

